import { Box, Card, CardContent, CardHeader, Grid } from "@mui/material";
import React, { useState } from "react";
import useGetPageInfo from "../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";
import SingleLineDiagram from "../../../components/graphical-view/SingleLineDiagram";
import { useLoaderData } from "react-router-dom";
import DropdownPicker from "../../../components/shared/dropdown";

const SingleLineDiagramPage = () => {
  const pageInfo = useGetPageInfo();
  const data = useLoaderData("root");
  const [substationId, setSubstationId] = useState(4);

  return (
    <Grid container spacing={3} className="gv-view-container ">
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title || "دیاگرام تک خطی ایستگاه"}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <DropdownPicker
                  label="ایستگاه"
                  value={substationId}
                  onChange={(event) => {
                    setSubstationId(event.target.value);
                  }}
                  list={data.substationList}
                  size="small"
                  optionName="substationName"
                  optionValue="id"
                  sx={{ minWidth: 200 }}
                />
              </Box>
            }
          />
          <CardContent>
            <Grid container spacing={3}>
              <SingleLineDiagram substationId={substationId} />
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SingleLineDiagramPage;
